import { render } from "./CmdAlias.vue?vue&type=template&id=4f960544"
import script from "./CmdAlias.vue?vue&type=script&lang=js"
export * from "./CmdAlias.vue?vue&type=script&lang=js"

import "./CmdAlias.vue?vue&type=style&index=0&id=4f960544&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__